import React, { forwardRef } from 'react'

import { cn } from '@/shared/lib/utils'

type ProgerssProps = {
	className?: string
	children?: React.ReactNode
}
function _Progress(
	{ className, children }: ProgerssProps,
	ref: React.Ref<HTMLDivElement>
) {
	return (
		<div
			ref={ref}
			className={cn('flex h-2 overflow-hidden rounded-lg bg-muted', className)}
		>
			{children}
		</div>
	)
}
const Progress = forwardRef<HTMLDivElement, ProgerssProps>(_Progress)
export default Progress
